// removed by extract-text-webpack-plugin
module.exports = {"brand":"#2f75c1","polarBear":"#f2f3f5","wolf":"#dcdee2","this":"ClassNavigationHeader__this___f2X4E","top":"ClassNavigationHeader__top___1BpxZ","bottom":"ClassNavigationHeader__bottom___3-Chn","settingsIcon":"ClassNavigationHeader__settingsIcon___17tL2","avatar":"ClassNavigationHeader__avatar___DtHeb","groupName":"ClassNavigationHeader__groupName___EY-EL","groupCode":"ClassNavigationHeader__groupCode___2gF94"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/ClassNavigationHeader.css
// module id = 2274
// module chunks = 0 1